import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface LocationListItemDTO {
  id: string;
  locationName: string;
  code: string;
  comment: string;
  pos: string;
  sms: string;
  exportSystem: string;
  tenant: string;
  appEnabled: boolean;
  disabled: boolean;
  /** Will be a string of text to display in a pop up.  Needs to be in format we can copy from. */
  details: string;
}
const LocationListItemDTO = {
  create: (initValues?: Partial<LocationListItemDTO>): LocationListItemDTO => {
    const defaults: LocationListItemDTO = {
      id: '',
      locationName: '',
      code: '',
      comment: '',
      pos: '',
      sms: '',
      exportSystem: '',
      tenant: '',
      appEnabled: false,
      disabled: false,
      details: '',
    };
    const fixedInitValues: Partial<LocationListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default LocationListItemDTO;
